import React from 'react';
import {Row, Col, Card} from 'react-materialize';


import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const Sobre = () => (

    <Card>

        <Row>
            <div align="center">
                <h5><p><b><FormattedMessage id={"non_sururgical_mask_text_title"} defaultMessage={"Nas máscaras não cirúrgicas, deve-se considerar o seguinte:"}/></b></p></h5>
            </div>
            <div align="justify" style={{padding:"50px"}}>
                <ul>
                    <li>• <FormattedMessage id={"non_sururgical_mask_text_1"} defaultMessage={"As máscaras devem ter pelo menos 3 camadas de tecido."}/></li>
                    <li>• <FormattedMessage id={"non_sururgical_mask_text_2"} defaultMessage={"Respirabilidade do material utilizado."}/></li>
                    <li>• <FormattedMessage id={"non_sururgical_mask_text_3"} defaultMessage={"Não passar água pelo tecido."}/></li>
                    <li>• <FormattedMessage id={"non_sururgical_mask_text_4"} defaultMessage={"Forma da máscara."}/></li>
                    <li>• <FormattedMessage id={"non_sururgical_mask_text_5"} defaultMessage={"Ajuste da máscara."}/></li>
                </ul>
            </div>
            <div align="center">
                <a href={"/masks"} style={{background:'white', color: 'black'}}>
                    <button style={{backgroundColor:"#7F7FFF", border:"white", borderRadius:"15px"}}>
                        <h5><FormattedMessage id={"back"} defaultMessage={"VOLTAR"}/></h5>
                    </button>
                </a>
            </div>
        </Row>

        

    </Card>

);

export default Sobre;